<template>
  <div id="comment_m" class="full">
    <div class="mainTitle1 textbox">
      <h3>Trusted By Our Customers</h3>
      <p>Let our customers to personally explain the use of our services and products.</p>
    </div>
    <div class="itembox">
      <swiper class="swiper1 swiper-no-swiping" ref="swipercom" :options="commentopt" :auto-update='true'>
        <swiper-slide class="item" v-for="(item,index) in list" :key="index">
          <div class="imgbox">
            <img :src="item.img" alt="" class="head">
            <img src="../assets/img/comment_icon.png" alt="" class="icon">
          </div>
          <div class="right">
            <div class="line">
              <span>{{item.name}}</span>
              <el-rate class="rate" v-model="rate" disabled></el-rate>
            </div>
            <p>{{item.text}}</p>
          </div>
        </swiper-slide>
      </swiper>
      <!--        <div class="swiper-button-prev sbp2" slot="button-prev"></div>-->
      <!--        <div class="swiper-button-next sbn2" slot="button-next" ref="swpcomnext"></div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "comment_m",
  props:{
    comopt:Object,
  },
  data(){
    return{
      rate:5,
      list:[
        {
          img:require('../assets/img/comment_img1.jpg'),
          name:'Laura , the United States',
          text:'Since installing Brotex products, the sonic difference has been really astounding in our concert hall. It was a really great auditory experience.',
        },
        {
          img:require('../assets/img/comment_img2.jpg'),
          name:'Ella , HK of China',
          text:'We are delighted to work with Brotex Acoustics. Their products and expertise have allowed us to set up one of our studios very quickly and with great results. ',
        },
        {
          img:require('../assets/img/comment_img3.jpg'),
          name:'Jimmy , UAE',
          text:'The perforated acoustic panels of Brotex are really good materials and look. They clean up all the extra reverb in the room, and we didn\'t need to fill the whole room with them.',
        },
        {
          img:require('../assets/img/comment_img4.jpg'),
          name:'Peter , the United States',
          text:'Our panels arrived on time without any delay. Thank you very much for completing such a large order perfectly. Looking forward to our next cooperation!',
        },
      ],
      commentopt:{
        direction: 'vertical',
        slidesPerView: 3,
        spaceBetween: 10,
        slidesPerColumnFill:'row',
        navigation: {
          nextEl: '.sbn2',
          prevEl: '.sbp2'
        },
      },
    }
  },
  watch:{
    comopt(newval){
      this.commentopt=newval
      // console.log('changed')
    },
  },
}
</script>

<style lang="less" scoped>
#comment_m{background: url("../assets/img/comment_bg.png") no-repeat 100% 0%/40% rgba(247,248,252);padding: .30rem 3%;
  /deep/ .swiper-slide{height: unset!important;}
  .itembox{display: flex;position: relative;
    .item{display: flex;align-items: center;background: white;padding: .1rem;
      .imgbox{position: relative;
        .head{border-radius: 50%;width: .5rem;height: .5rem;object-fit: cover;}
        .icon{position: absolute;bottom: 0%;right: -10%;width: .2rem;height: .2rem;}
      }
      .right{margin-left: .2rem;
        .line{display: flex;justify-content: space-between;align-items: baseline;
          &>span{font: .14rem Poppins-Medium;color: @main-c4;}
          .rate{
            /deep/ .el-rate__icon{font-size: .12rem;margin-right: .03rem;}
          }
        }
        p{font: .12rem/.18rem Poppins-Regular;color: #657788;}
      }
    }
  }
}
</style>